import I18n from 'I18n';
import debounce from 'react-utils/debounce';
import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getVid } from 'find-and-filter-data/search-and-filter-schema/protected';
import UISelect from 'UIComponents/input/UISelect';
import { getVid as getContactVid, getEmail } from 'conversations-inbox-lib/contacts/public/operators';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { loadOptions } from '../operators/contactFilterOptionOperators';
import { AsyncUIAvatar } from 'svh-workspace-ui-lib/code-splitting/public';
import { jsx as _jsx } from "react/jsx-runtime";
const UPDATE_FILTER_DEBOUNCE_MS = 500;
export const addAvatarToOption = option => {
  return Object.assign({}, option, {
    avatar: getEmail(option.contact) &&
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ size: string; email: string | undefined; }... Remove this comment to see the full error message
    _jsx(AsyncUIAvatar, {
      size: "xs",
      email: getEmail(option.contact)
    })
  });
};
const debouncedLoadOptions = debounce((searchQuery, callback, pagination, setOptions, setError) => {
  loadOptions({
    searchQuery,
    callback,
    pagination,
    optionTransformation: addAvatarToOption
  }).then(builtOptions => {
    setOptions(builtOptions.options);
  }).catch(() => {
    setError(true);
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
}, UPDATE_FILTER_DEBOUNCE_MS);
const ContactFilter = () => {
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(false);
  const {
    filterValues,
    setFilterValue
  } = useFilterValues();
  const placeholder = I18n.text('conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.contact.placeholder');
  const searchPlaceholder = I18n.text('conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.contact.search-placeholder');
  const id = 'offline-fallback-select';
  const handleSetFilter = vid => {
    const option = options.find(optionValue => getContactVid(optionValue.contact) === vid);
    if (option) setFilterValue('vid', option.contact);else setFilterValue('vid', null);
  };
  const handleLoadOptions = useCallback((searchQuery, callback, pagination) => debouncedLoadOptions(searchQuery, callback, pagination, setOptions, setError), [setOptions, setError]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.contact.title"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      clearable: true,
      "data-test-id": "contact-filter",
      error: error,
      loadOptions: handleLoadOptions,
      id: id,
      defaultValue: undefined,
      value:
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Contact | null' is not assignabl... Remove this comment to see the full error message
      getVid(filterValues) ? getContactVid(getVid(filterValues)) : undefined,
      onChange: e => handleSetFilter(e.target.value),
      placeholder: placeholder,
      placement: "bottom right",
      searchPlaceholder: searchPlaceholder
    })
  });
};
ContactFilter.displayName = 'ContactFilter';
export default ContactFilter;